(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7989],{

/***/ 35727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ state_of_personalization_report_2021; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/tracking/scripts/index.ts + 2 modules
var scripts = __webpack_require__(17397);
// EXTERNAL MODULE: ../../libs/utils/useInView/index.ts + 1 modules
var useInView = __webpack_require__(85807);
// EXTERNAL MODULE: ../../libs/utils/useLottie/useLottie.tsx
var useLottie = __webpack_require__(73849);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/Hero/assets/personalization-hero-lottie.json.data
/* harmony default export */ var personalization_hero_lottie_json = ("/_next/static/data/personalization-hero-lottie.json-151f161ad952dd813784f94bba63d5cf.json");
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/Hero/Hero.tsx



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var data = {
  title: "2021 State of Personalization Report",
  description: "From nice-to-have to necessity for intelligent customer engagement.",
  button: {
    title: "Download the report",
    href: "https://learn.segment.com/state-of-personalization-2021/"
  }
};

var Hero = function Hero() {
  var _useState = (0,react.useState)(),
      animationData = _useState[0],
      setAnimationData = _useState[1];

  (0,react.useEffect)(function () {
    setAnimationData(fetch(personalization_hero_lottie_json));
  }, []);

  var _useLottie = (0,useLottie/* default */.Z)({
    options: {
      autoplay: false,
      animationData: animationData,
      loop: false
    }
  }),
      _useLottie2 = (0,slicedToArray/* default */.Z)(_useLottie, 2),
      animation = _useLottie2[0],
      containerRef = _useLottie2[1];

  var isInView = (0,useInView/* default */.Z)(containerRef);
  (0,react.useEffect)(function () {
    if (isInView) {
      animation === null || animation === void 0 ? void 0 : animation.play();
    }
  }, [animation, isInView]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* default */.ZP, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h1",
            variant: "h1",
            children: data.title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pExtraLarge",
            children: data.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            color: "primary",
            size: "large",
            variant: "filled",
            href: data.button.href,
            onClick: function onClick() {
              return (0,scripts/* trackButtonClick */.kO)({
                buttonText: data.button.title,
                targetUrl: data.button.href
              });
            },
            children: data.button.title
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Animation, {
          ref: containerRef
        })
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e138voxc1"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var Animation = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e138voxc0"
} : 0)( true ? {
  name: "1j3ybdt",
  styles: "display:grid;width:100%;aspect-ratio:580/582"
} : 0);

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../libs/matcha/components/Media/index.ts + 2 modules
var Media = __webpack_require__(75091);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/PersonalizationTakes/assets/personalization-takes-lottie.json.data
/* harmony default export */ var personalization_takes_lottie_json = ("/_next/static/data/personalization-takes-lottie.json-28be060930d5273258f070b57014f62d.json");
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/PersonalizationTakes/PersonalizationTakes.tsx











var PersonalizationTakes_data = {
  title: "Personalization takes on new urgency",
  descriptions: ["2020 transformed consumer behavior like never before. With stay-at-home orders in place and brick-and-mortar businesses closed, companies of all sizes were forced to reconsider their customer engagement strategies. However, this \u201Cflight to digital\u201D radically increased consumers' expectations far faster than what many brands were ready for.", "Overnight, consumers expected brands to remember who they were, where they came from, and what they liked, regardless of what channel they came from.", "This promise of personalized, one-to-one marketing might once have been a pipe dream. It is now increasingly table stakes for consumers today. But as consumers\u2019 expectations rise, are businesses equipped to deliver these experiences?"]
};

var PersonalizationTakes = function PersonalizationTakes() {
  var _useState = (0,react.useState)(),
      animationData = _useState[0],
      setAnimationData = _useState[1];

  (0,react.useEffect)(function () {
    setAnimationData(fetch(personalization_takes_lottie_json));
  }, []);

  var _useLottie = (0,useLottie/* default */.Z)({
    options: {
      autoplay: false,
      animationData: animationData,
      loop: false
    }
  }),
      _useLottie2 = (0,slicedToArray/* default */.Z)(_useLottie, 2),
      animation = _useLottie2[0],
      containerRef = _useLottie2[1];

  var isInView = (0,useInView/* default */.Z)(containerRef);
  (0,react.useEffect)(function () {
    if (isInView) {
      animation === null || animation === void 0 ? void 0 : animation.play();
    }
  }, [animation, isInView]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    reverse: true,
    variant: "2Col",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
        greaterThan: "md",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonalizationTakes_Animation, {
          ref: containerRef
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: PersonalizationTakes_data.title
        }), PersonalizationTakes_data.descriptions.map(function (description, key) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pLarge",
            children: description
          }, key);
        })]
      })
    })]
  });
};

var PersonalizationTakes_Animation = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10vri2a0"
} : 0)("max-width:400px;margin:0 auto;aspect-ratio:338/585;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("md");
}, "{margin:0 30px 0 auto;}" + ( true ? "" : 0));

/* harmony default export */ var PersonalizationTakes_PersonalizationTakes = (PersonalizationTakes);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Brandbook.ts + 92 modules
var Brandbook = __webpack_require__(79550);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var Card = __webpack_require__(74881);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/KeyFindings/KeyFindings.tsx








var KeyFindings_data = {
  title: "Key findings",
  description: "Insightful takeaways from the report, at a glance.",
  items: [{
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* AnalyticsIcon */.Ie, {
      size: "large"
    }),
    title: "Consumer expectations are outpacing experiences",
    description: "While 85% of the businesses studied by Twilio Segment believe they are offering personalized experiences, only 60% of consumers seem to think that\u2019s the case.",
    href: "https://segment.com/#content-1"
  }, {
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* ParentIcon */.dk, {
      size: "large"
    }),
    title: "Customer loyalty is on the line",
    description: "If brands fail to offer a personalized experience, 45% of consumers say they\u2019re likely to take their business elsewhere.",
    href: "https://segment.com/#content-1-1"
  }, {
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* CompliantIcon */.Kg, {
      size: "large"
    }),
    title: "Personalization and privacy aren\u2019t mutually exclusive",
    description: "69% of consumers say they appreciate personalization, so long as it\u2019s based on data they\u2019ve shared with a business directly.",
    href: "https://segment.com/#content-2"
  }, {
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* FocusIcon */.Yx, {
      size: "large"
    }),
    title: "Personalization requires good data",
    description: "43% of organizations see accurate, real-time customer data as the biggest challenge to their personalization efforts.",
    href: "https://segment.com/#content-d1-1"
  }, {
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* PiechartIcon */.ff, {
      size: "large"
    }),
    title: "Omnichannel barriers",
    description: "75% of businesses are failing to deliver omnichannel personalization, with departmental silos and legacy infrastructure the key barriers to success.",
    href: "https://segment.com/#content-d2"
  }, {
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* UserIcon */.tB, {
      size: "large"
    }),
    title: "The future is first-party",
    description: "80% of businesses say they are using at least some first-party data to personalize the customer experience.",
    href: "https://segment.com/#content-2-2"
  }]
};

var KeyFindings = function KeyFindings() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h2",
          children: KeyFindings_data.title
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: KeyFindings_data.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
        overrides: {
          md: 2,
          xl: 3
        },
        children: KeyFindings_data.items.map(function (_ref, key) {
          var icon = _ref.icon,
              title = _ref.title,
              description = _ref.description,
              href = _ref.href;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.ZP, {
            href: href,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Body */.uT, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Accessories */.v8, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* AccessoriesRow */.OW, {
                  children: icon
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Copy */.CK, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Headline */.s0, {
                  children: title
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Description */.dk, {
                  children: description
                })]
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Action */.aU, {
                alignment: "right",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronRightIcon */.XC, {})
              })]
            })
          }, key);
        })
      })
    })]
  });
};

/* harmony default export */ var KeyFindings_KeyFindings = (KeyFindings);
// EXTERNAL MODULE: ../../node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(24330);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/AsDigitalSoars/AsDigitalSoars.tsx


function AsDigitalSoars_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var AsDigitalSoars_data = {
  title: "As digital soars,<br/>personalization is within reach.",
  description: "To remain competitive, highly personalized customer experiences, built on a foundation of first-party data, have become the primary means of driving customer loyalty and differentiation, as well as a higher bottom line for businesses."
};

var AsDigitalSoars = function AsDigitalSoars() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* default */.ZP, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h2",
            variant: "h2",
            dangerouslySetInnerHTML: {
              __html: sanitize_html_default()(AsDigitalSoars_data.title, {
                allowedTags: ["br"]
              })
            }
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pLarge",
            children: AsDigitalSoars_data.description
          })]
        })
      })
    })
  });
};

var TextWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1x0kw1k0"
} : 0)( true ? {
  name: "16oo1aq",
  styles: "max-width:684px;margin:0 auto"
} : 0);

/* harmony default export */ var AsDigitalSoars_AsDigitalSoars = (AsDigitalSoars);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/PersonalizationIsNoLongerAnOption/assets/personalization-is-no-longer-an-option-lottie.json.data
/* harmony default export */ var personalization_is_no_longer_an_option_lottie_json = ("/_next/static/data/personalization-is-no-longer-an-option-lottie.json-0eda828fc794a8f64a6c91fb5b2da469.json");
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/PersonalizationIsNoLongerAnOption/PersonalizationIsNoLongerAnOption.tsx



function PersonalizationIsNoLongerAnOption_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var PersonalizationIsNoLongerAnOption_data = {
  title: "Personalization is no longer an option. It\u2019s a necessity.",
  content: [{
    title: "Offering personalized digital experiences used to be a nice-to-have. Now it\u2019s essential.",
    description: "Both businesses and consumers agree: 75% of businesses believe personalization is table stakes, while over half of consumers say personalization improves the customer experience."
  }, {
    title: "What customers say:",
    description: "\u201CHaving Segment not only helped us do the personalization work we\u2019ve always wanted to do, but we can now improve on the effectiveness of our ad campaigns and create a better feedback loop.\u201D"
  }, {
    author: "Christian Rocha Castillo",
    position: "Deputy Director Ecommerce/Digital Media at Domino\u2019s Pizza",
    button: {
      title: "Read the full story",
      href: "https://segment.com/customers/dominos/?utm_medium=referral&utm_source=segment&utm_campaign=nam_cnt_state-of-personalization_&utm_content=case-study"
    }
  }]
};

var PersonalizationIsNoLongerAnOption = function PersonalizationIsNoLongerAnOption() {
  var _useState = (0,react.useState)(),
      animationData = _useState[0],
      setAnimationData = _useState[1];

  (0,react.useEffect)(function () {
    setAnimationData(fetch(personalization_is_no_longer_an_option_lottie_json));
  }, []);

  var _useLottie = (0,useLottie/* default */.Z)({
    options: {
      autoplay: false,
      animationData: animationData,
      loop: false
    }
  }),
      _useLottie2 = (0,slicedToArray/* default */.Z)(_useLottie, 2),
      animation = _useLottie2[0],
      containerRef = _useLottie2[1];

  var isInView = (0,useInView/* default */.Z)(containerRef);
  (0,react.useEffect)(function () {
    if (isInView) {
      animation === null || animation === void 0 ? void 0 : animation.play();
    }
  }, [animation, isInView]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "2Col",
    reverse: true,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonalizationIsNoLongerAnOption_Animation, {
        ref: containerRef
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: PersonalizationIsNoLongerAnOption_data.title
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Content, {
          children: PersonalizationIsNoLongerAnOption_data.content.map(function (_ref, key) {
            var title = _ref.title,
                description = _ref.description,
                author = _ref.author,
                position = _ref.position,
                button = _ref.button;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Item, {
              children: [title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
                tag: "h3",
                variant: "h5",
                children: title
              }), description && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
                variant: "pMedium",
                children: description
              }), author && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
                tag: "h3",
                variant: "h6",
                children: author
              }), position && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Position, {
                variant: "textTiny",
                children: position
              }), button && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
                href: button.href,
                iconEnd: Common/* ChevronRightIcon */.XC,
                children: button.title
              })]
            }, key);
          })
        })]
      })
    })]
  });
};

var PersonalizationIsNoLongerAnOption_Animation = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e11v35mk3"
} : 0)( true ? {
  name: "1rkdowg",
  styles: "max-width:450px;margin:0 auto;aspect-ratio:450/650"
} : 0);

var Position = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Description */.dk,  true ? {
  target: "e11v35mk2"
} : 0)( true ? {
  name: "1h6krc",
  styles: "margin-top:-10px"
} : 0);

var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e11v35mk1"
} : 0)( true ? {
  name: "f70my9",
  styles: "margin-top:48px"
} : 0);

var Item = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e11v35mk0"
} : 0)( true ? "" : 0);

/* harmony default export */ var PersonalizationIsNoLongerAnOption_PersonalizationIsNoLongerAnOption = (PersonalizationIsNoLongerAnOption);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/BusinessesInvesting/assets/businesses-investing-lottie.json.data
/* harmony default export */ var businesses_investing_lottie_json = ("/_next/static/data/businesses-investing-lottie.json-81cca5ae36ad97fc236e5fc133ff7192.json");
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/BusinessesInvesting/BusinessesInvesting.tsx



function BusinessesInvesting_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var BusinessesInvesting_data = {
  title: "Businesses investing in personalization are unlocking greater ROI.",
  content: {
    heading: "Businesses investing in personalization stand to drive greater revenue from those that don\u2019t.",
    description: ["60% of consumers say they will become repeat buyers after a personalized shopping experience with a retailer. When Segment asked consumers the same question in 2017, only 44% said the same.", "What\u2019s more, nearly half say they\u2019re less likely to make a purchase from a brand after an unpersonalized experience."],
    secondHeading: "The Vintage Bar increased conversions over 33% with just one personalization tactic.",
    button: {
      title: "Learn how",
      href: "https://segment.com/customers/the-vintage-bar/"
    }
  },
  animation: {
    title: "How likely are you to become a repeat buyer after a personalized shopping experience?"
  }
};

var BusinessesInvesting = function BusinessesInvesting() {
  var _useState = (0,react.useState)(),
      animationData = _useState[0],
      setAnimationData = _useState[1];

  (0,react.useEffect)(function () {
    setAnimationData(fetch(businesses_investing_lottie_json));
  }, []);

  var _useLottie = (0,useLottie/* default */.Z)({
    options: {
      autoplay: false,
      animationData: animationData,
      loop: false
    }
  }),
      _useLottie2 = (0,slicedToArray/* default */.Z)(_useLottie, 2),
      animation = _useLottie2[0],
      containerRef = _useLottie2[1];

  var isInView = (0,useInView/* default */.Z)(containerRef);
  (0,react.useEffect)(function () {
    if (isInView) {
      animation === null || animation === void 0 ? void 0 : animation.play();
    }
  }, [animation, isInView]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "2Col",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
      alignSelf: "center",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h4",
          children: BusinessesInvesting_data.animation.title
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BusinessesInvesting_Animation, {
        ref: containerRef
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: BusinessesInvesting_data.title
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BusinessesInvesting_Content, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h3",
            variant: "h5",
            children: BusinessesInvesting_data.content.heading
          }), BusinessesInvesting_data.content.description.map(function (text, key) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
              tag: "p",
              variant: "pMedium",
              children: text
            }, key);
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h3",
            variant: "h6",
            children: BusinessesInvesting_data.content.secondHeading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
            href: BusinessesInvesting_data.content.button.href,
            iconEnd: Common/* ChevronRightIcon */.XC,
            children: BusinessesInvesting_data.content.button.title
          })]
        })]
      })
    })]
  });
};

var BusinessesInvesting_Animation = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ea9prik1"
} : 0)( true ? {
  name: "1c0yc8x",
  styles: "margin-top:40px;max-width:560px;aspect-ratio:540/290"
} : 0);

var BusinessesInvesting_Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ea9prik0"
} : 0)( true ? {
  name: "f70my9",
  styles: "margin-top:48px"
} : 0);

/* harmony default export */ var BusinessesInvesting_BusinessesInvesting = (BusinessesInvesting);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/AttitudesTowardPrivacy/AttitudesTowardPrivacy.tsx


function AttitudesTowardPrivacy_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var AttitudesTowardPrivacy_data = {
  title: "Attitudes toward privacy are changing, and businesses are having to keep up.",
  description: "To meet demands for privacy and security, businesses have to dedicate more resources to ensuring customer data is collected in a secure manner, while still ensuring they're delivering the customer-first experiences that consumers expect."
};

var AttitudesTowardPrivacy = function AttitudesTowardPrivacy() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* default */.ZP, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AttitudesTowardPrivacy_TextWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h2",
            variant: "h2",
            children: AttitudesTowardPrivacy_data.title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pLarge",
            children: AttitudesTowardPrivacy_data.description
          })]
        })
      })
    })
  });
};

var AttitudesTowardPrivacy_TextWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eb2zckc0"
} : 0)( true ? {
  name: "z9xs2w",
  styles: "max-width:844px;margin:0 auto"
} : 0);

/* harmony default export */ var AttitudesTowardPrivacy_AttitudesTowardPrivacy = (AttitudesTowardPrivacy);
// EXTERNAL MODULE: ../../libs/matcha/components/Elevation/index.ts + 2 modules
var Elevation = __webpack_require__(33606);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/TrustIsGoodBusiness/assets/trust-is-good-business-lottie.json.data
/* harmony default export */ var trust_is_good_business_lottie_json = ("/_next/static/data/trust-is-good-business-lottie.json-1b9eba8f20a390e84025db65d05c7a7d.json");
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/TrustIsGoodBusiness/TrustIsGoodBusiness.tsx



function TrustIsGoodBusiness_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var TrustIsGoodBusiness_data = {
  title: "Trust is good business.",
  content: ["Digital trust must be a cornerstone of a brand\u2019s digital transformation. Customer relationships are at stake.", "55% of consumers say trustworthiness and transparency are the most important traits of a brand."],
  animation: {
    title: "When deciding whether to shop with a particular brand, what\u2019s most important?"
  }
};

var TrustIsGoodBusiness = function TrustIsGoodBusiness() {
  var _useState = (0,react.useState)(),
      animationData = _useState[0],
      setAnimationData = _useState[1];

  (0,react.useEffect)(function () {
    setAnimationData(fetch(trust_is_good_business_lottie_json));
  }, []);

  var _useLottie = (0,useLottie/* default */.Z)({
    options: {
      autoplay: false,
      animationData: animationData,
      loop: false
    }
  }),
      _useLottie2 = (0,slicedToArray/* default */.Z)(_useLottie, 2),
      animation = _useLottie2[0],
      containerRef = _useLottie2[1];

  var isInView = (0,useInView/* default */.Z)(containerRef);
  (0,react.useEffect)(function () {
    if (isInView) {
      animation === null || animation === void 0 ? void 0 : animation.play();
    }
  }, [animation, isInView]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "2Col",
    reverse: true,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h4",
          children: TrustIsGoodBusiness_data.animation.title
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Elevation/* default */.Z, {
        elevation: 3,
        type: "dropShadow",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustIsGoodBusiness_Animation, {
          ref: containerRef
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: TrustIsGoodBusiness_data.title
        }), TrustIsGoodBusiness_data.content.map(function (text, key) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pLarge",
            children: text
          }, key);
        })]
      })
    })]
  });
};

var TrustIsGoodBusiness_Animation = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ea8nx190"
} : 0)( true ? {
  name: "6p5i01",
  styles: "margin-top:40px;max-width:534px;aspect-ratio:534/408"
} : 0);

/* harmony default export */ var TrustIsGoodBusiness_TrustIsGoodBusiness = (TrustIsGoodBusiness);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/CustomersAreSplit/assets/customers-are-split-lottie.json.data
/* harmony default export */ var customers_are_split_lottie_json = ("/_next/static/data/customers-are-split-lottie.json-bf83915923de5eb61ab121bd7e943440.json");
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/CustomersAreSplit/CustomersAreSplit.tsx



function CustomersAreSplit_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var CustomersAreSplit_data = {
  title: "Consumers are split about data security.",
  content: "Consumers are divided about whether brands are acting in their best interest: 37% of consumers say they trust businesses to keep their personal data secure and use it responsibly, but another 37% don\u2019t trust online retailers with their personal data.",
  animation: {
    title: "Do you trust retail brands to keep your personal data secure and use it responsibly?"
  }
};

var CustomersAreSplit = function CustomersAreSplit() {
  var _useState = (0,react.useState)(),
      animationData = _useState[0],
      setAnimationData = _useState[1];

  (0,react.useEffect)(function () {
    setAnimationData(fetch(customers_are_split_lottie_json));
  }, []);

  var _useLottie = (0,useLottie/* default */.Z)({
    options: {
      autoplay: false,
      animationData: animationData,
      loop: false
    }
  }),
      _useLottie2 = (0,slicedToArray/* default */.Z)(_useLottie, 2),
      animation = _useLottie2[0],
      containerRef = _useLottie2[1];

  var isInView = (0,useInView/* default */.Z)(containerRef);
  (0,react.useEffect)(function () {
    if (isInView) {
      animation === null || animation === void 0 ? void 0 : animation.play();
    }
  }, [animation, isInView]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "2Col",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        centered: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h4",
          children: CustomersAreSplit_data.animation.title
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomersAreSplit_Animation, {
        ref: containerRef
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: CustomersAreSplit_data.title
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: CustomersAreSplit_data.content
        })]
      })
    })]
  });
};

var CustomersAreSplit_Animation = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebgjye00"
} : 0)( true ? {
  name: "vyhh1e",
  styles: "margin:40px auto 0 auto;max-width:421px;aspect-ratio:421/242"
} : 0);

/* harmony default export */ var CustomersAreSplit_CustomersAreSplit = (CustomersAreSplit);
// EXTERNAL MODULE: ../../libs/matcha/recipes/PropCard/index.ts + 6 modules
var PropCard = __webpack_require__(62456);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2021/components/PersonalizationStrategies/assets/PersonalizationStrategies@2x.png
var PersonalizationStrategies_2x = __webpack_require__(11947);
var PersonalizationStrategies_2x_default = /*#__PURE__*/__webpack_require__.n(PersonalizationStrategies_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2021/components/PersonalizationStrategies/assets/PersonalizationStrategies.webp
var PersonalizationStrategies = __webpack_require__(20376);
var PersonalizationStrategies_default = /*#__PURE__*/__webpack_require__.n(PersonalizationStrategies);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2021/components/PersonalizationStrategies/assets/PersonalizationStrategies@2x.webp
var assets_PersonalizationStrategies_2x = __webpack_require__(53865);
var assets_PersonalizationStrategies_2x_default = /*#__PURE__*/__webpack_require__.n(assets_PersonalizationStrategies_2x);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/PersonalizationStrategies/PersonalizationStrategiesImage.tsx







var PersonalizationStrategiesImage = function PersonalizationStrategiesImage(_ref) {
  var alt = _ref.alt;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((PersonalizationStrategies_default()), ", ").concat((assets_PersonalizationStrategies_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (PersonalizationStrategies_2x_default()),
      alt: alt,
      width: "329",
      height: "400",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var PersonalizationStrategies_PersonalizationStrategiesImage = (PersonalizationStrategiesImage);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/PersonalizationStrategies/PersonalizationStrategies.tsx


function PersonalizationStrategies_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var PersonalizationStrategies_data = {
  title: "9 Personalization strategies to try in 2021",
  content: "Your customers deserve more than surface level personalization, so get your personalization off the ground with these tried and tested strategies.",
  button: {
    title: "Download now",
    href: "https://learn.segment.com/personalization-strategies-2021/"
  }
};

var PersonalizationStrategies_PersonalizationStrategies = function PersonalizationStrategies() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var mobileResolutionMediaQuery = theme.breakpoints.down("xs", false);
  var isMobileResolution = (0,useMatchMedia/* default */.Z)(mobileResolutionMediaQuery, true);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* default */.ZP, {
    variant: "noCopy",
    sticky: true,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PropCard/* default */.ZP, {
          reverse: isMobileResolution,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PropCard/* Copy */.CK, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropCard/* Title */.Dx, {
              children: PersonalizationStrategies_data.title
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropCard/* Text */.xv, {
              children: PersonalizationStrategies_data.content
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
              color: "primary",
              href: PersonalizationStrategies_data.button.href,
              size: "large",
              variant: "filled",
              children: PersonalizationStrategies_data.button.title
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropCard/* Img */.Ei, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonalizationStrategies_PersonalizationStrategiesImage, {
              alt: "Illustration: ".concat(PersonalizationStrategies_data.title)
            })
          })]
        })
      })
    })
  });
};

var CardWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "efv4e920"
} : 0)( true ? {
  name: "55z0",
  styles: "max-width:800px;margin:0 auto"
} : 0);

/* harmony default export */ var components_PersonalizationStrategies_PersonalizationStrategies = (PersonalizationStrategies_PersonalizationStrategies);
// EXTERNAL MODULE: ../../libs/matcha/components/Badge/index.ts + 2 modules
var Badge = __webpack_require__(16154);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2021/components/Guides/assets/DataPrivacy.png
var DataPrivacy = __webpack_require__(49168);
var DataPrivacy_default = /*#__PURE__*/__webpack_require__.n(DataPrivacy);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2021/components/Guides/assets/IdentityResolution.png
var IdentityResolution = __webpack_require__(22194);
var IdentityResolution_default = /*#__PURE__*/__webpack_require__.n(IdentityResolution);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/Guides/Guides.tsx


function Guides_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var Guides_data = [{
  image: (IdentityResolution_default()),
  badge: "eBook",
  title: "Identity Resolution: A guide to the post-cookie world",
  description: "With the imminent death of the cookie, companies must invest in a first-party identity resolution solution to stay ahead of the pack.",
  button: "Download the guide",
  url: "https://learn.segment.com/identity-resolution/"
}, {
  image: (DataPrivacy_default()),
  badge: "eBook",
  title: "Data Privacy: A practical guide to data privacy planning ",
  description: "Confused by the rapidly evolving data privacy landscape? In this guide you\u2019ll learn more about data privacy and key considerations for GDPR, CCPA, Schrems II, browser privacy changes, mobile ad IDs, and more.",
  button: "Download the guide",
  url: "https://learn.segment.com/data-privacy-ebook/"
}];

var Guides = function Guides() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* default */.ZP, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumnTrack, {
        overrides: {
          md: 2
        },
        children: Guides_data.map(function (_ref, key) {
          var image = _ref.image,
              badge = _ref.badge,
              title = _ref.title,
              description = _ref.description,
              button = _ref.button,
              url = _ref.url;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* default */.ZP, {
            href: url,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCardImage, {
              alt: "Illustration: ".concat(title),
              src: image,
              variant: "fill"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Body */.uT, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Accessories */.v8, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* AccessoriesRow */.OW, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
                    variant: "outlined",
                    children: badge
                  })
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Copy */.CK, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Headline */.s0, {
                  tag: "h3",
                  children: title
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Description */.dk, {
                  children: description
                })]
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Action */.aU, {
                alignment: "left",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
                  iconEnd: Common/* ChevronRightIcon */.XC,
                  children: button
                })
              })]
            })]
          }, key);
        })
      })
    })
  });
};

var StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "enw6xb71"
} : 0)( true ? {
  name: "55z0",
  styles: "max-width:800px;margin:0 auto"
} : 0);

var StyledCardImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Card/* Image */.Ee,  true ? {
  target: "enw6xb70"
} : 0)( true ? {
  name: "8glp6h",
  styles: "height:216px"
} : 0);

/* harmony default export */ var Guides_Guides = (Guides);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/PersonalizedExperiences/PersonalizedExperiences.tsx


function PersonalizedExperiences_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var HEADLINE = "Personalized experiences and data privacy aren\u2019t mutually exclusive.";
var DESCRIPTION = "The evolution of consumer privacy has cleared the way for first-party data, collected about a business\u2019 own interactions with its own customers, to move into the spotlight. Thankfully, in today\u2019s digital world, that\u2019s hardly a scarce resource.";

var PersonalizedExperiences = function PersonalizedExperiences() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
    variant: "centered",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionContents, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: HEADLINE
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: DESCRIPTION
        })]
      })
    })
  });
};

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "esay1k71"
} : 0)(Section/* Wrapper */.im, "{gap:0;}" + ( true ? "" : 0));

var StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "esay1k70"
} : 0)( true ? {
  name: "837xmr",
  styles: "max-width:684px"
} : 0);

/* harmony default export */ var PersonalizedExperiences_PersonalizedExperiences = (PersonalizedExperiences);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/StrikingTheBalance/assets/striking-the-balance-lottie.json.data
/* harmony default export */ var striking_the_balance_lottie_json = ("/_next/static/data/striking-the-balance-lottie.json-d71b8a3ea72caa39dd2cbf73c94f243a.json");
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/StrikingTheBalance/StrikingTheBalance.tsx



function StrikingTheBalance_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var StrikingTheBalance_HEADLINE = "Striking the balance between convenience and privacy.";

var description = (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
    tag: "p",
    variant: "pLarge",
    children: "While overall knowledge of data security is on the rise, there appears to be a genuine willingness to share data safely and securely in exchange for the convenience of personalization."
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
    tag: "p",
    variant: "pLarge",
    children: "Almost half of consumers say they\u2019re happy to exchange personal data in exchange for personalization."
  })]
});

var StrikingTheBalance = function StrikingTheBalance() {
  var _useState = (0,react.useState)(),
      animationData = _useState[0],
      setAnimationData = _useState[1];

  (0,react.useEffect)(function () {
    setAnimationData(fetch(striking_the_balance_lottie_json));
  }, []);

  var _useLottie = (0,useLottie/* default */.Z)({
    options: {
      autoplay: false,
      animationData: animationData,
      loop: false
    }
  }),
      _useLottie2 = (0,slicedToArray/* default */.Z)(_useLottie, 2),
      animation = _useLottie2[0],
      containerRef = _useLottie2[1];

  var isInView = (0,useInView/* default */.Z)(containerRef);
  (0,react.useEffect)(function () {
    if (isInView) {
      animation === null || animation === void 0 ? void 0 : animation.play();
    }
  }, [animation, isInView]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "2Col",
    reverse: true,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StrikingTheBalance_Animation, {
        ref: containerRef
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: StrikingTheBalance_HEADLINE
        }), description]
      })
    })]
  });
};

/* harmony default export */ var StrikingTheBalance_StrikingTheBalance = (StrikingTheBalance);

var StrikingTheBalance_Animation = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1wv3dtq0"
} : 0)( true ? {
  name: "10mil45",
  styles: "max-width:447px;margin:0 auto;aspect-ratio:447/581"
} : 0);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/PersonalizationAndPrivacy/assets/personalization-and-privacy.json.data
/* harmony default export */ var personalization_and_privacy_json = ("/_next/static/data/personalization-and-privacy.json-4b3a0b4436330ecde1ea209c03522193.json");
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/PersonalizationAndPrivacy/PersonalizationAndPrivacy.tsx



function PersonalizationAndPrivacy_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var PersonalizationAndPrivacy_HEADLINE = "Personalization and privacy: getting the best of both worlds.";

var PersonalizationAndPrivacy_description = (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
    tag: "p",
    variant: "pLarge",
    children: "Customers want personalized experiences and are increasingly willing to provide their data in order to get it."
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
    tag: "p",
    variant: "pLarge",
    children: "69% of consumers say they are fine with personalization, so long as it\u2019s data they\u2019ve shared with a business directly."
  })]
});

var PersonalizationAndPrivacy = function PersonalizationAndPrivacy() {
  var _useState = (0,react.useState)(),
      animationData = _useState[0],
      setAnimationData = _useState[1];

  (0,react.useEffect)(function () {
    setAnimationData(fetch(personalization_and_privacy_json));
  }, []);

  var _useLottie = (0,useLottie/* default */.Z)({
    options: {
      autoplay: false,
      animationData: animationData,
      loop: false
    }
  }),
      _useLottie2 = (0,slicedToArray/* default */.Z)(_useLottie, 2),
      animation = _useLottie2[0],
      containerRef = _useLottie2[1];

  var isInView = (0,useInView/* default */.Z)(containerRef);
  (0,react.useEffect)(function () {
    if (isInView) {
      animation === null || animation === void 0 ? void 0 : animation.play();
    }
  }, [animation, containerRef, isInView]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "2Col",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonalizationAndPrivacy_Animation, {
        ref: containerRef
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: PersonalizationAndPrivacy_HEADLINE
        }), PersonalizationAndPrivacy_description]
      })
    })]
  });
};

/* harmony default export */ var PersonalizationAndPrivacy_PersonalizationAndPrivacy = (PersonalizationAndPrivacy);

var PersonalizationAndPrivacy_Animation = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ty16820"
} : 0)( true ? {
  name: "155jdvo",
  styles: "max-width:447px;margin:0 auto;aspect-ratio:447/572"
} : 0);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/PotholesAlongTheCustomerJourney/PotholesAlongTheCustomerJourney.tsx


function PotholesAlongTheCustomerJourney_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var PotholesAlongTheCustomerJourney_HEADLINE = "Potholes along the customer journey emerge.";
var PotholesAlongTheCustomerJourney_DESCRIPTION = "Despite consumers using more channels and devices than ever before, few businesses are prepared to deliver consistent, personalized experiences across channels.";

var PotholesAlongTheCustomerJourney = function PotholesAlongTheCustomerJourney() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PotholesAlongTheCustomerJourney_StyledSectionBase, {
    variant: "centered",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PotholesAlongTheCustomerJourney_StyledSectionContents, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: PotholesAlongTheCustomerJourney_HEADLINE
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: PotholesAlongTheCustomerJourney_DESCRIPTION
        })]
      })
    })
  });
};

var PotholesAlongTheCustomerJourney_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ekx782h1"
} : 0)(Section/* Wrapper */.im, "{gap:0;}" + ( true ? "" : 0));

var PotholesAlongTheCustomerJourney_StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "ekx782h0"
} : 0)( true ? {
  name: "837xmr",
  styles: "max-width:684px"
} : 0);

/* harmony default export */ var PotholesAlongTheCustomerJourney_PotholesAlongTheCustomerJourney = (PotholesAlongTheCustomerJourney);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/TheOmnichannelImperative/assets/the-omnichannel-imperative-lottie.json.data
/* harmony default export */ var the_omnichannel_imperative_lottie_json = ("/_next/static/data/the-omnichannel-imperative-lottie.json-2e65eb4e439d6156a77e4ea30e8e6fe3.json");
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/TheOmnichannelImperative/TheOmnichannelImperative.tsx



function TheOmnichannelImperative_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var TheOmnichannelImperative_HEADLINE = "The omnichannel imperative.";

var Description = function Description() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
      tag: "p",
      variant: "pLarge",
      children: "More and more consumers (69% to be specific) expect a personal and consistent customer experience across multiple different channels, both physical and digital. Yet few businesses are following through with it."
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
      tag: "p",
      variant: "pLarge",
      children: "Just 24% of businesses say they are investing successfully in omnichannel personalization."
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
      tag: "p",
      variant: "h6",
      tokens: {
        color: theme.palette.twilio.gray[100]
      },
      children: "Rugs.com unified its owned and paid channels to achieve 400% revenue growth"
    })]
  });
};

var TheOmnichannelImperative_link = {
  href: "/customers/rugs-dot-com/",
  text: "Read how"
};

var TheOmnichannelImperative = function TheOmnichannelImperative() {
  var _useState = (0,react.useState)(),
      animationData = _useState[0],
      setAnimationData = _useState[1];

  (0,react.useEffect)(function () {
    setAnimationData(fetch(the_omnichannel_imperative_lottie_json));
  }, []);

  var _useLottie = (0,useLottie/* default */.Z)({
    options: {
      autoplay: false,
      animationData: animationData,
      loop: false
    }
  }),
      _useLottie2 = (0,slicedToArray/* default */.Z)(_useLottie, 2),
      animation = _useLottie2[0],
      containerRef = _useLottie2[1];

  var isInView = (0,useInView/* default */.Z)(containerRef);
  (0,react.useEffect)(function () {
    if (isInView) {
      animation === null || animation === void 0 ? void 0 : animation.play();
    }
  }, [animation, isInView]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "2Col",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TheOmnichannelImperative_Animation, {
        ref: containerRef
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: TheOmnichannelImperative_HEADLINE
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
          size: "medium",
          href: TheOmnichannelImperative_link.href,
          children: TheOmnichannelImperative_link.text
        })]
      })
    })]
  });
};

/* harmony default export */ var TheOmnichannelImperative_TheOmnichannelImperative = (TheOmnichannelImperative);

var TheOmnichannelImperative_Animation = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1rl2ucq0"
} : 0)( true ? {
  name: "71z7bu",
  styles: "max-width:640px;margin:0 auto;aspect-ratio:560/280"
} : 0);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/OmnichannelSuccess/assets/the-omnichannel-success.json.data
/* harmony default export */ var the_omnichannel_success_json = ("/_next/static/data/the-omnichannel-success.json-6cab4239644f5c94fd97e67d3d77f089.json");
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/OmnichannelSuccess/OmnichannelSuccess.tsx



function OmnichannelSuccess_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var OmnichannelSuccess_HEADLINE = "Omnichannel success requires quality as much as quantity.";

var OmnichannelSuccess_description = (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
    tag: "p",
    variant: "pLarge",
    children: "As well as adding more channels, businesses are concentrating on reducing fragmentation between the channels they\u2019ve already invested in. Consumers agree. Given a choice, 61% say they\u2019d prefer fewer, better channels when shopping with a brand."
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
    tag: "p",
    variant: "h5",
    children: "What customers say:"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
    tag: "p",
    variant: "pMedium",
    children: "\u201CSegment has become the data hub that we needed. There isn\u2019t a question on how or when data will get from one place to another. We feel confident we can execute communications and insights in the right way with the right data.\u201D"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
    tag: "p",
    variant: "h6",
    children: "Ann Ehnert"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
    tag: "p",
    variant: "textTiny",
    children: "Manager of CRM & Loyalty Marketing at Schnuck Markets"
  })]
});

var OmnichannelSuccess_link = {
  href: "/customers/schnucks/?utm_medium=referral&utm_source=segment&utm_campaign=nam_cnt_state-of-personalization_&utm_content=case-study",
  text: "Read the full story"
};

var OmnichannelSuccess = function OmnichannelSuccess() {
  var _useState = (0,react.useState)(),
      animationData = _useState[0],
      setAnimationData = _useState[1];

  (0,react.useEffect)(function () {
    setAnimationData(fetch(the_omnichannel_success_json));
  }, []);

  var _useLottie = (0,useLottie/* default */.Z)({
    options: {
      autoplay: false,
      animationData: animationData,
      loop: false
    }
  }),
      _useLottie2 = (0,slicedToArray/* default */.Z)(_useLottie, 2),
      animation = _useLottie2[0],
      containerRef = _useLottie2[1];

  var isInView = (0,useInView/* default */.Z)(containerRef);
  (0,react.useEffect)(function () {
    if (isInView) {
      animation === null || animation === void 0 ? void 0 : animation.play();
    }
  }, [animation, isInView]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "2Col",
    reverse: true,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OmnichannelSuccess_Animation, {
        ref: containerRef
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: OmnichannelSuccess_HEADLINE
        }), OmnichannelSuccess_description, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
          size: "medium",
          href: OmnichannelSuccess_link.href,
          children: OmnichannelSuccess_link.text
        })]
      })
    })]
  });
};

/* harmony default export */ var OmnichannelSuccess_OmnichannelSuccess = (OmnichannelSuccess);

var OmnichannelSuccess_Animation = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eu82it30"
} : 0)( true ? {
  name: "1iopbw5",
  styles: "max-width:566px;margin:0 auto;aspect-ratio:566/639"
} : 0);
// EXTERNAL MODULE: ../../libs/matcha/components/VideoPlayer/index.ts + 2 modules
var VideoPlayer = __webpack_require__(41926);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2021/components/OrchestrateIntelligentEngagement/assets/Cover@2x.png
var Cover_2x = __webpack_require__(85861);
var Cover_2x_default = /*#__PURE__*/__webpack_require__.n(Cover_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2021/components/OrchestrateIntelligentEngagement/assets/Cover.webp
var Cover = __webpack_require__(24130);
var Cover_default = /*#__PURE__*/__webpack_require__.n(Cover);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2021/components/OrchestrateIntelligentEngagement/assets/Cover@2x.webp
var assets_Cover_2x = __webpack_require__(27117);
var assets_Cover_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Cover_2x);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/OrchestrateIntelligentEngagement/OrchestrateIntelligentEngagement.tsx











var HEADING = "Orchestrate intelligent engagement";
var OrchestrateIntelligentEngagement_DESCRIPTION = "Meet the first customer journey builder for the digital-first era, powered by Twilio Segment.";
var OrchestrateIntelligentEngagement_link = {
  href: "/product/twilio-engage/journeys/",
  text: "Learn more"
};
var VIDEO_URL = "https://vimeo.com/559103187?embedded=true&source=vimeo_logo&owner=50788297";

var CoverImage = function CoverImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoPlayer/* Cover */.Y9, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat((Cover_default()), ", ").concat((assets_Cover_2x_default()), " 2x")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
        width: 1280,
        height: 752,
        src: (Cover_2x_default()),
        alt: ""
      })]
    })
  });
};

var OrchestrateIntelligentEngagement = function OrchestrateIntelligentEngagement() {
  var _useState = (0,react.useState)(false),
      playing = _useState[0],
      setPlaying = _useState[1];

  var play = function play() {
    return setPlaying(true);
  };

  var stop = function stop() {
    return setPlaying(false);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: HEADING
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: OrchestrateIntelligentEngagement_DESCRIPTION
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
          href: OrchestrateIntelligentEngagement_link.href,
          children: OrchestrateIntelligentEngagement_link.text
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoPlayer/* default */.ZP, {
        url: VIDEO_URL,
        playing: playing,
        onPause: stop,
        onPlay: play,
        children: !playing && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoPlayer/* BigPlayButton */.sT, {
            ariaLabel: "Play Button",
            onClick: play
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CoverImage, {}, "cover")]
        })
      })
    })]
  });
};

/* harmony default export */ var OrchestrateIntelligentEngagement_OrchestrateIntelligentEngagement = (OrchestrateIntelligentEngagement);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
// EXTERNAL MODULE: ../../libs/matcha/components/IconWrapper/index.ts + 2 modules
var IconWrapper = __webpack_require__(79600);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/PersonalizeOrPerish/PersonalizeOrPerish.tsx


function PersonalizeOrPerish_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var OVERLINE = "Conclusion";
var PersonalizeOrPerish_HEADLINE = "Personalize or perish";

var content = (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
    tag: "p",
    variant: "h5",
    children: "The State of Personalization makes it clear that brands only face two choices: personalize or perish."
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
    tag: "p",
    variant: "pMedium",
    children: "The digital acceleration sparked by the pandemic has created a new reality and new expectations. If brands fail to take this seriously, customers will simply walk away and support the competition."
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
    tag: "p",
    variant: "pMedium",
    children: "If you\u2019d like to join the 20,000+ customers using Segment Twilio to power their personalization strategies, get started today."
  })]
});

var list = ["Segment conducted this research using online surveys distributed by RepData.", "Survey respondents were n=2,700 adult consumers who have purchased something online in the past 6 months, and n=300 adult manager+ decision-makers at consumer-facing companies that provide goods and/or services online.", "Respondents were from the United States, United Kingdom, Australia, and New Zealand.", "Data was collected from April 8 to April 20, 2021."];

var PersonalizeOrPerish = function PersonalizeOrPerish() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var mobileResolutionMediaQuery = theme.breakpoints.down("md", false);
  var isSmallResolution = (0,useMatchMedia/* default */.Z)(mobileResolutionMediaQuery, false);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "2Col",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
          tag: "span",
          variant: "h5",
          children: OVERLINE
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyTextHeading, {
          tag: "h2",
          variant: "h2",
          children: PersonalizeOrPerish_HEADLINE
        }), content]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
          gap: "small",
          tag: "ul",
          children: list.map(function (item) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* default */.ZP, {
              tag: "li",
              alignment: "left",
              headerPosition: isSmallResolution ? "top" : "left",
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Header */.h4, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper/* default */.Z, {
                  elevation: 1,
                  variant: "circle",
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* CheckIcon */.nQ, {
                    color: theme.palette.twilio.gray[100]
                  })
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Body */.uT, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledText, {
                  children: item
                })
              })]
            }, item);
          })
        })
      })
    })]
  });
};

/* harmony default export */ var PersonalizeOrPerish_PersonalizeOrPerish = (PersonalizeOrPerish);

var StyledText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FeatureBox/* Text */.xv,  true ? {
  target: "e9mj3i82"
} : 0)( true ? {
  name: "1d9hs7o",
  styles: "margin:0;align-self:center"
} : 0);

var StyledCopyTextHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Heading */.X6,  true ? {
  target: "e9mj3i81"
} : 0)("margin-bottom:40px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("md");
}, "{margin-bottom:48px;}" + ( true ? "" : 0));

var ListWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e9mj3i80"
} : 0)("margin:0 auto;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{padding-top:48px;max-width:452px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/GettingStarted/GettingStarted.tsx


function GettingStarted_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var GettingStarted = function GettingStarted(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Getting started is easy" : _ref$heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "Start connecting your data with Segment" : _ref$description;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h2",
          children: heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GettingStarted_Content, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
          children: "Get a demo"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
          variant: "outlined",
          tag: "a",
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Create a free account"
        })]
      })]
    })
  });
};

var GettingStarted_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1gv1i8t2"
} : 0)( true ? {
  name: "1fhwumf",
  styles: "overflow-y:auto;overflow-x:hidden;padding-top:80px;padding-bottom:80px"
} : 0);

var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1gv1i8t1"
} : 0)("display:grid;justify-content:center;row-gap:40px;padding:0 20px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 30px;}" + ( true ? "" : 0));

var GettingStarted_Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1gv1i8t0"
} : 0)("display:grid;max-width:520px;width:100%;margin:0 auto;grid-template-columns:1fr 1fr;grid-template-rows:auto;gap:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{grid-template-columns:auto;max-width:327px;}" + ( true ? "" : 0));

/* harmony default export */ var GettingStarted_GettingStarted = (GettingStarted);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2021/components/RecommendedReading/assets/TheCustomerDataPlatformReport2021.png
var TheCustomerDataPlatformReport2021 = __webpack_require__(59005);
var TheCustomerDataPlatformReport2021_default = /*#__PURE__*/__webpack_require__.n(TheCustomerDataPlatformReport2021);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2021/components/RecommendedReading/assets/WaysToUseDataToEngageYourCustomers.png
var WaysToUseDataToEngageYourCustomers = __webpack_require__(74337);
var WaysToUseDataToEngageYourCustomers_default = /*#__PURE__*/__webpack_require__.n(WaysToUseDataToEngageYourCustomers);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2021/components/RecommendedReading/assets/Personalization102AdvancedGuideToPersonalization.png
var Personalization102AdvancedGuideToPersonalization = __webpack_require__(83836);
var Personalization102AdvancedGuideToPersonalization_default = /*#__PURE__*/__webpack_require__.n(Personalization102AdvancedGuideToPersonalization);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/components/RecommendedReading/RecommendedReading.tsx


function RecommendedReading_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var RecommendedReading_data = [{
  image: (TheCustomerDataPlatformReport2021_default()),
  badge: "Report",
  title: "The Customer Data Platform Report 2021",
  description: "We analyzed ten trillion data points to find out how the Customer Data Platform market is evolving.",
  button: "Download the report",
  url: "https://learn.segment.com/customer-data-platform-report-2021/"
}, {
  image: (WaysToUseDataToEngageYourCustomers_default()),
  badge: "Guide",
  title: "15 Ways to Use Data to Engage Your Customers",
  description: "This guide shares 15 different ways you can use Segment and Twilio to make your customer engagement more intelligent across every channel.",
  button: "Download the guide",
  url: "https://learn.segment.com/15-ways-to-use-data/"
}, {
  image: (Personalization102AdvancedGuideToPersonalization_default()),
  badge: "Guide",
  title: "Personalization 102: Advanced Guide to Personalization",
  description: "This guide goes beyond fluffy best practices to help you up-level your efforts with personalization.",
  button: "Download the guide",
  url: "https://learn.segment.com/advanced-personalization-guide/"
}];
var RecommendedReading_HEADING = "Recommended reading";

var RecommendedReading = function RecommendedReading() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSection, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        centered: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h2",
          children: RecommendedReading_HEADING
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RecommendedReading_StyledColumnTrack, {
        overrides: {
          md: 3
        },
        children: RecommendedReading_data.map(function (_ref, key) {
          var image = _ref.image,
              badge = _ref.badge,
              title = _ref.title,
              description = _ref.description,
              button = _ref.button,
              url = _ref.url;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* default */.ZP, {
            href: url,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RecommendedReading_StyledCardImage, {
              alt: "Illustration: ".concat(title),
              src: image,
              variant: "fill"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Body */.uT, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Accessories */.v8, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* AccessoriesRow */.OW, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
                    variant: "outlined",
                    children: badge
                  })
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Copy */.CK, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Headline */.s0, {
                  children: title
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Description */.dk, {
                  children: description
                })]
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Action */.aU, {
                alignment: "left",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
                  iconEnd: Common/* ChevronRightIcon */.XC,
                  children: button
                })
              })]
            })]
          }, key);
        })
      })
    })]
  });
};

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1suv5ch2"
} : 0)(Section/* Wrapper */.im, "{row-gap:40px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{row-gap:80px;}}" + ( true ? "" : 0));

var RecommendedReading_StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "e1suv5ch1"
} : 0)( true ? {
  name: "z68zft",
  styles: "margin:0 auto;max-width:1120px"
} : 0);

var RecommendedReading_StyledCardImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Card/* Image */.Ee,  true ? {
  target: "e1suv5ch0"
} : 0)( true ? {
  name: "1gu7cpf",
  styles: "height:198px"
} : 0);

/* harmony default export */ var RecommendedReading_RecommendedReading = (RecommendedReading);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2021/assets/OgStateOfPersonalizationReport2021.png
var OgStateOfPersonalizationReport2021 = __webpack_require__(14007);
var OgStateOfPersonalizationReport2021_default = /*#__PURE__*/__webpack_require__.n(OgStateOfPersonalizationReport2021);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2021/StateOfPersonalizationReport2021.tsx































var StateOfPersonalizationReport2021 = function StateOfPersonalizationReport2021() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "2021 State of Personalization Report  | Twilio Segment",
      pageDescription: "The State of Personalization report looks at how attitudes, preferences, and experiences with personalization have evolved over the past year. This report features survey data from 3,000+ businesses and consumers worldwide to explore expectations for digital experiences, data privacy, personalization, and more.",
      pageOG: (OgStateOfPersonalizationReport2021_default()),
      themeColor: theme.palette.twilio.green[10],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonalizationTakes_PersonalizationTakes, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyFindings_KeyFindings, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AsDigitalSoars_AsDigitalSoars, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonalizationIsNoLongerAnOption_PersonalizationIsNoLongerAnOption, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BusinessesInvesting_BusinessesInvesting, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_PersonalizationStrategies_PersonalizationStrategies, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AttitudesTowardPrivacy_AttitudesTowardPrivacy, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustIsGoodBusiness_TrustIsGoodBusiness, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomersAreSplit_CustomersAreSplit, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Guides_Guides, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonalizedExperiences_PersonalizedExperiences, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StrikingTheBalance_StrikingTheBalance, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonalizationAndPrivacy_PersonalizationAndPrivacy, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PotholesAlongTheCustomerJourney_PotholesAlongTheCustomerJourney, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TheOmnichannelImperative_TheOmnichannelImperative, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OmnichannelSuccess_OmnichannelSuccess, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrchestrateIntelligentEngagement_OrchestrateIntelligentEngagement, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonalizeOrPerish_PersonalizeOrPerish, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BottomBackground, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted_GettingStarted, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RecommendedReading_RecommendedReading, {})]
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e8dcx271"
} : 0)( true ? "" : 0);

/* harmony default export */ var StateOfPersonalizationReport2021_StateOfPersonalizationReport2021 = (StateOfPersonalizationReport2021);

var BottomBackground = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e8dcx270"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding-bottom:80px;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/pages/state-of-personalization-report-2021/index.tsx



var StateOfPersonalizationReport = function StateOfPersonalizationReport() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StateOfPersonalizationReport2021_StateOfPersonalizationReport2021, {});
};

/* harmony default export */ var state_of_personalization_report_2021 = (StateOfPersonalizationReport);

/***/ }),

/***/ 12795:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;

var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

var _loadable = _interop_require_default(__webpack_require__(84949));

function dynamic(dynamicOptions, options) {
  var loadableFn = _loadable["default"];
  var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
    // A loading component is not required, so we default it
    loading: function loading(_ref) {
      var error = _ref.error,
          isLoading = _ref.isLoading,
          pastDelay = _ref.pastDelay;
      if (!pastDelay) return null;

      if (false) {}

      return null;
    }
  }; // Support for direct import(), eg: dynamic(import('../hello-world'))
  // Note that this is only kept for the edge case where someone is passing in a promise as first argument
  // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
  // To make sure we don't execute the import without rendering first

  if (dynamicOptions instanceof Promise) {
    loadableOptions.loader = function () {
      return dynamicOptions;
    }; // Support for having import as a function, eg: dynamic(() => import('../hello-world'))

  } else if (typeof dynamicOptions === 'function') {
    loadableOptions.loader = dynamicOptions; // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
  } else if (typeof dynamicOptions === 'object') {
    loadableOptions = _extends({}, loadableOptions, dynamicOptions);
  } // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})


  loadableOptions = _extends({}, loadableOptions, options); // Error if Fizz rendering is not enabled and `suspense` option is set to true

  if (false) {}

  if (loadableOptions.suspense) {
    if (false) {}

    delete loadableOptions.ssr;
    delete loadableOptions.loading;
  } // coming from build/babel/plugins/react-loadable-plugin.js


  if (loadableOptions.loadableGenerated) {
    loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
    delete loadableOptions.loadableGenerated;
  } // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
  // skip `ssr` for suspense mode and opt-in React.lazy directly


  if (typeof loadableOptions.ssr === 'boolean' && !loadableOptions.suspense) {
    if (!loadableOptions.ssr) {
      delete loadableOptions.ssr;
      return noSSR(loadableFn, loadableOptions);
    }

    delete loadableOptions.ssr;
  }

  return loadableFn(loadableOptions);
}

var isServerSide = false;

function noSSR(LoadableInitializer, loadableOptions) {
  // Removing webpack and modules means react-loadable won't try preloading
  delete loadableOptions.webpack;
  delete loadableOptions.modules; // This check is necessary to prevent react-loadable from initializing on the server

  if (!isServerSide) {
    return LoadableInitializer(loadableOptions);
  }

  var Loading = loadableOptions.loading; // This will only be rendered on the server side

  return function () {
    return /*#__PURE__*/_react["default"].createElement(Loading, {
      error: null,
      isLoading: true,
      pastDelay: false,
      timedOut: false
    });
  };
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 49749:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LoadableContext = void 0;

var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

var LoadableContext = _react["default"].createContext(null);

exports.LoadableContext = LoadableContext;

if (false) {}

/***/ }),

/***/ 84949:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__(22624);

var _createClass = __webpack_require__(85458);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

var _loadableContext = __webpack_require__(49749);

var _ref =  true ? __webpack_require__(2784) : 0,
    useSyncExternalStore = _ref.useSyncExternalStore;

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;

function load(loader) {
  var promise = loader();
  var state = {
    loading: true,
    loaded: null,
    error: null
  };
  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  })["catch"](function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });
  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj["default"] : obj;
}

function createLoadableComponent(loadFn, options) {
  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    webpack: null,
    modules: null,
    suspense: false
  }, options);

  if (opts.suspense) {
    opts.lazy = _react["default"].lazy(opts.loader);
  }
  /** @type LoadableSubscription */


  var subscription = null;

  function init() {
    if (!subscription) {
      var sub = new LoadableSubscription(loadFn, opts);
      subscription = {
        getCurrentValue: sub.getCurrentValue.bind(sub),
        subscribe: sub.subscribe.bind(sub),
        retry: sub.retry.bind(sub),
        promise: sub.promise.bind(sub)
      };
    }

    return subscription.promise();
  } // Server only


  if (false) {} // Client only


  if (!initialized && true) {
    // require.resolveWeak check is needed for environments that don't have it available like Jest
    var moduleIds = opts.webpack && "function" === 'function' ? opts.webpack() : opts.modules;

    if (moduleIds) {
      READY_INITIALIZERS.push(function (ids) {
        var _iterator = _createForOfIteratorHelper(moduleIds),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var moduleId = _step.value;

            if (ids.indexOf(moduleId) !== -1) {
              return init();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
  }

  function useLoadableModule() {
    init();

    var context = _react["default"].useContext(_loadableContext.LoadableContext);

    if (context && Array.isArray(opts.modules)) {
      opts.modules.forEach(function (moduleName) {
        context(moduleName);
      });
    }
  }

  function LoadableImpl(props, ref) {
    useLoadableModule();
    var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);

    _react["default"].useImperativeHandle(ref, function () {
      return {
        retry: subscription.retry
      };
    }, []);

    return _react["default"].useMemo(function () {
      if (state.loading || state.error) {
        return _react["default"].createElement(opts.loading, {
          isLoading: state.loading,
          pastDelay: state.pastDelay,
          timedOut: state.timedOut,
          error: state.error,
          retry: subscription.retry
        });
      } else if (state.loaded) {
        return _react["default"].createElement(resolve(state.loaded), props);
      } else {
        return null;
      }
    }, [props, state]);
  }

  function LazyImpl(props, ref) {
    useLoadableModule();
    return _react["default"].createElement(opts.lazy, _extends({}, props, {
      ref: ref
    }));
  }

  var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;

  LoadableComponent.preload = function () {
    return init();
  };

  LoadableComponent.displayName = 'LoadableComponent';
  return _react["default"].forwardRef(LoadableComponent);
}

var LoadableSubscription = /*#__PURE__*/function () {
  function LoadableSubscription(loadFn, opts) {
    _classCallCheck(this, LoadableSubscription);

    this._loadFn = loadFn;
    this._opts = opts;
    this._callbacks = new Set();
    this._delay = null;
    this._timeout = null;
    this.retry();
  }

  _createClass(LoadableSubscription, [{
    key: "promise",
    value: function promise() {
      return this._res.promise;
    }
  }, {
    key: "retry",
    value: function retry() {
      var _this = this;

      this._clearTimeouts();

      this._res = this._loadFn(this._opts.loader);
      this._state = {
        pastDelay: false,
        timedOut: false
      };
      var res = this._res,
          opts = this._opts;

      if (res.loading) {
        if (typeof opts.delay === 'number') {
          if (opts.delay === 0) {
            this._state.pastDelay = true;
          } else {
            this._delay = setTimeout(function () {
              _this._update({
                pastDelay: true
              });
            }, opts.delay);
          }
        }

        if (typeof opts.timeout === 'number') {
          this._timeout = setTimeout(function () {
            _this._update({
              timedOut: true
            });
          }, opts.timeout);
        }
      }

      this._res.promise.then(function () {
        _this._update({});

        _this._clearTimeouts();
      })["catch"](function (_err) {
        _this._update({});

        _this._clearTimeouts();
      });

      this._update({});
    }
  }, {
    key: "_update",
    value: function _update(partial) {
      this._state = _extends({}, this._state, {
        error: this._res.error,
        loaded: this._res.loaded,
        loading: this._res.loading
      }, partial);

      this._callbacks.forEach(function (callback) {
        return callback();
      });
    }
  }, {
    key: "_clearTimeouts",
    value: function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    }
  }, {
    key: "getCurrentValue",
    value: function getCurrentValue() {
      return this._state;
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      var _this2 = this;

      this._callbacks.add(callback);

      return function () {
        _this2._callbacks["delete"](callback);
      };
    }
  }]);

  return LoadableSubscription;
}();

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function flushInitializers(initializers, ids) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init(ids));
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers, ids);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolveInitializers, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
  });
};

Loadable.preloadReady = function () {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new Promise(function (resolvePreload) {
    var res = function res() {
      initialized = true;
      return resolvePreload();
    }; // We always will resolve, errors should be handled within loading UIs.


    flushInitializers(READY_INITIALIZERS, ids).then(res, res);
  });
};

if (true) {
  window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}

var _default = Loadable;
exports["default"] = _default;

/***/ }),

/***/ 33514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Dx; },
/* harmony export */   "Hq": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Hq; },
/* harmony export */   "ZP": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Ob; },
/* harmony export */   "h4": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.h4; },
/* harmony export */   "uT": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.uT; },
/* harmony export */   "xv": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.xv; }
/* harmony export */ });
/* harmony import */ var _FeatureBox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13379);

_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .FeatureBox.displayName */ .Ob.displayName = "FeatureBoxBase";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Body.displayName */ .uT.displayName = "FeatureBox.Body";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Header.displayName */ .h4.displayName = "FeatureBox.Header";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Text.displayName */ .xv.displayName = "FeatureBox.Text";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Title.displayName */ .Dx.displayName = "FeatureBox.Title";


/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 56052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Layout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6372);


/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ }),

/***/ 73849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var lottie_web__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12039);
/* harmony import */ var lottie_web__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lottie_web__WEBPACK_IMPORTED_MODULE_2__);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



/**
 * A hook that provides an animation instance and a ref to the container element.
 * @param options The options to configure the animation.
 * @returns The animation instance and a ref to the container element.
 */

var useLottie = function useLottie(_ref) {
  var options = _ref.options;
  var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      animationInstance = _useState[0],
      setAnimationInstance = _useState[1];

  var initializedRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (!containerRef || !options.animationData || initializedRef.current) {
      return;
    }

    initializedRef.current = true;
    options.animationData.then(function (response) {
      return typeof response.json === "function" ? response.json() : response;
    }).then(function (data) {
      setAnimationInstance(lottie_web__WEBPACK_IMPORTED_MODULE_2___default().loadAnimation(_objectSpread(_objectSpread({
        container: containerRef.current
      }, options), {}, {
        animationData: data
      })));
    });
    return function () {
      return animationInstance === null || animationInstance === void 0 ? void 0 : animationInstance.destroy();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerRef, options.animationData]);
  return [animationInstance, containerRef];
};

/* harmony default export */ __webpack_exports__["Z"] = (useLottie);

/***/ }),

/***/ 3834:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/state-of-personalization-report-2021",
      function () {
        return __webpack_require__(35727);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 25237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(12795)


/***/ }),

/***/ 14007:
/***/ (function(module) {

module.exports = "/_next/static/images/OgStateOfPersonalizationReport2021-67ce43f22c1ecc3c49dff1e24fc50cf6.png";

/***/ }),

/***/ 49168:
/***/ (function(module) {

module.exports = "/_next/static/images/DataPrivacy-a86397f7224a886fd1730bef9bff621d.png";

/***/ }),

/***/ 22194:
/***/ (function(module) {

module.exports = "/_next/static/images/IdentityResolution-d6684d843b20245f96a5672e03ce52d2.png";

/***/ }),

/***/ 85861:
/***/ (function(module) {

module.exports = "/_next/static/images/Cover@2x-9cbe45d7b9196dd44f8f12bef2ae3129.png";

/***/ }),

/***/ 11947:
/***/ (function(module) {

module.exports = "/_next/static/images/PersonalizationStrategies@2x-286f9b8b6eb4cf90b6ee3c157189e2b1.png";

/***/ }),

/***/ 83836:
/***/ (function(module) {

module.exports = "/_next/static/images/Personalization102AdvancedGuideToPersonalization-128f582ebfad665102799c4b2c61be7c.png";

/***/ }),

/***/ 59005:
/***/ (function(module) {

module.exports = "/_next/static/images/TheCustomerDataPlatformReport2021-b825b3dd943f9f5be3f512602eb69985.png";

/***/ }),

/***/ 74337:
/***/ (function(module) {

module.exports = "/_next/static/images/WaysToUseDataToEngageYourCustomers-90ab0a984ae08fd1ecf5e70cfff82ff1.png";

/***/ }),

/***/ 24130:
/***/ (function(module) {

module.exports = "/_next/static/images/Cover-3f404ebef06d2a0d98e86d13bc4c68dd.webp";

/***/ }),

/***/ 27117:
/***/ (function(module) {

module.exports = "/_next/static/images/Cover@2x-517efd5b2c49d4e26760d5cb4d7b3a49.webp";

/***/ }),

/***/ 20376:
/***/ (function(module) {

module.exports = "/_next/static/images/PersonalizationStrategies-c67695dc3592078e6b61385981e827c2.webp";

/***/ }),

/***/ 53865:
/***/ (function(module) {

module.exports = "/_next/static/images/PersonalizationStrategies@2x-55792db8f5fc08770a2743c11448b349.webp";

/***/ }),

/***/ 45302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ rng; }
/* harmony export */ });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/***/ }),

/***/ 20708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ unsafeStringify; }
/* harmony export */ });

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (stringify)));

/***/ }),

/***/ 20982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_browser_v4; }
});

;// CONCATENATED MODULE: ../../node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ var esm_browser_native = ({
  randomUUID
});
// EXTERNAL MODULE: ../../node_modules/uuid/dist/esm-browser/rng.js
var rng = __webpack_require__(45302);
// EXTERNAL MODULE: ../../node_modules/uuid/dist/esm-browser/stringify.js
var stringify = __webpack_require__(20708);
;// CONCATENATED MODULE: ../../node_modules/uuid/dist/esm-browser/v4.js




function v4(options, buf, offset) {
  if (esm_browser_native.randomUUID && !buf && !options) {
    return esm_browser_native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng/* default */.Z)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return (0,stringify/* unsafeStringify */.S)(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);

/***/ }),

/***/ 76527:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 96969:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 32232:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 24195:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7642,3287,9097,6577,3607,8834,4330,1382,4136,2073,8392,5735,2429,7303,8187,3996,4881,3379,9550,9600,3970,9774,2888,179], function() { return __webpack_exec__(3834); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);